import { MiniAppCoreError } from '../config/error'
import { EnvironmentDisplay } from '../types/public'
import decodeJWT from './jwt-decode'

// https://stackoverflow.com/a/1349426
function makeId(length: number): string {
  let result = ''
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }

  return result
}

function generateRequestTransId(): string {
  return makeId(24) // TODO change length
}

/**
 * helper function for get mobile platform
 * https://docs.videojs.com/utils_browser.js.html
 */
function getMobilePlatform(): MobilePlatform {
  const ua = (window.navigator && window.navigator.userAgent) || ''
  const isAndroid = /Android/i.test(ua)
  const isEdge = /Edg/i.test(ua)
  const isChrome = !isEdge && (/Chrome/i.test(ua) || /CriOS/i.test(ua))
  const isSafari = /Safari/i.test(ua) && !isChrome && !isAndroid && !isEdge
  const touchEnabled = Boolean(
    document === window.document &&
      ('ontouchstart' in window ||
        window.navigator.maxTouchPoints ||
        (window.DocumentTouch &&
          window.document instanceof window.DocumentTouch))
  )
  const isIpod = /iPod/i.test(ua)
  const isIpad =
    /iPad/i.test(ua) || (isSafari && touchEnabled && !/iPhone/i.test(ua))
  const isIphone = /iPhone/i.test(ua) && !isIpad

  if (isAndroid) {
    return 'Android'
  } else if (isIphone || isIpad || isIpod) {
    return 'iOS'
  }

  // throw new PlatformUnsupportedError(ua);
  throw new MiniAppCoreError('PLATFORM_UNSUPPORTED', { cause: ua })
}

/**
 * verify the current mobile platform is support or not?
 */
function verifyMobilePlatform(): MobilePlatform {
  const currentPlatform = getMobilePlatform()
  // copy logic from the old sdk (seven-eleven-javascript-sdk)
  switch (currentPlatform) {
    case 'Android':
      if (!Android) {
        throw new MiniAppCoreError('PLATFORM_FEATURE_MISSING_ANDROID')
      }
      if (!Android.webEchoMessage) {
        throw new MiniAppCoreError(
          'PLATFORM_FEATURE_MISSING_ANDROID_WEB_ECHO_MESSAGE'
        )
      }
      break
    case 'iOS':
      if (!window.webkit) {
        throw new MiniAppCoreError('PLATFORM_FEATURE_MISSING_IOS_WEBKIT')
      }
      if (!window.webkit.messageHandlers) {
        throw new MiniAppCoreError(
          'PLATFORM_FEATURE_MISSING_IOS_WEBKIT_MESSAGE_HANDLERS'
        )
      }
      break
  }
  return currentPlatform
}

function isEmpty(payload: any): Boolean {
  return (
    payload == null ||
    (typeof payload === 'object' && Object.keys(payload).length === 0) ||
    (typeof payload === 'string' && payload.trim().length === 0)
  )
}

function getUserIdFromScope(scope: string): string {
  const parts = scope.split('user_id:')
  return parts[1].split(' ')[0]
}

function normalizeEnvironmentDisplay(env: string): EnvironmentDisplay {
  const normalized = env.toLowerCase()
  if (['prod', 'production'].includes(normalized)) {
    return EnvironmentDisplay.PRODUCTION
  } else if (['uat', 'stg', 'staging'].includes(normalized)) {
    return EnvironmentDisplay.STAGING
  } else if (['dev', 'development'].includes(normalized)) {
    return EnvironmentDisplay.DEVELOPMENT
  }
  return (
    Object.values(EnvironmentDisplay).find((value) => value === normalized) ??
    EnvironmentDisplay.UNKNOWN
  )
}

export {
  makeId,
  generateRequestTransId,
  getMobilePlatform,
  verifyMobilePlatform,
  isEmpty,
  getUserIdFromScope,
  decodeJWT,
  normalizeEnvironmentDisplay,
}
